import {NgModule} from '@angular/core';
import {AngularFireModule} from '@angular/fire/compat';
import {getFirestore, provideFirestore} from '@angular/fire/firestore';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {provideEffectsManager} from '@ngneat/effects-ng';
import {
  ConfigService,
  CoreModule,
  FirebaseConfig,
  FirebaseModule,
  provideAkitaDevtools,
  provideAppInitializers,
  provideAuthInterceptor
} from '@q9elements/ui-kit/common';
import {LoadingPlaceholderModule, PageLoaderComponent} from '@q9elements/ui-kit/components';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {environment} from '../environments/environment';
import {provideErrorInterceptor} from './shared/interceptors/error.interceptor';
import {provideErrorHandler} from './shared/models/error-handler';
import {WrapperModule} from './shared/modules/wrapper/wrapper.module';

ConfigService.setConfig({environment, appName: 'sysAdmin'});

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    WrapperModule,
    FirebaseModule,
    LoadingPlaceholderModule,
    AngularFireModule.initializeApp(environment.fbConfig as Partial<FirebaseConfig>),
    provideFirestore(() => getFirestore()),
    PageLoaderComponent,
    MatSnackBarModule
  ],
  providers: [
    !ConfigService.environment.production ? provideAkitaDevtools() : [],
    provideAuthInterceptor(),
    provideErrorInterceptor(),
    provideErrorHandler(),
    provideAppInitializers(),
    provideEffectsManager()
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
